import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import SPKit from "../components/simcardPurchase/shop/sp-kit/spkit";
import SPMsisdn from "../components/simcardPurchase/shop/msisdn/msisdn";
import SPProfile from "../components/simcardPurchase/shop/profile/profile";
import SpPreFactor from "../components/simcardPurchase/shop/prefactor/Prefactor";
import SPDocument from "../components/simcardPurchase/shop/document/doc-print";
import SPFinalFactor from "../components/simcardPurchase/shop/final/final";
import SPFKit from "../components/simcardPurchase/foreigners/spf-kit/spf-kit";
import SPFMsisdn from "../components/simcardPurchase/foreigners/spf-msisdn/spf-msisdn";
import SPFAuthentication from "../components/simcardPurchase/foreigners/spf-authentication/spf-authentication";
import SPFProfile from "../components/simcardPurchase/foreigners/spf-profile/spf-profile";
import SPFPrefactor from "../components/simcardPurchase/foreigners/spf-prefactor/spf-prefactor";
import SPFDocument from "../components/simcardPurchase/foreigners/spf-document/spf-document";
import SPFFinalFactor from "../components/simcardPurchase/foreigners/spf-final/spf-final";
import SPListPendingDocument from "../components/simcardPurchase/pending/list/spListPendingDocument";
import SPPendingDocument from "../components/simcardPurchase/pending/document/spPendingDocument";
import SPReportList from "../components/simcardPurchase/reports/report-list/sp-report";

export const simCardPurchaseRoutes = [
	// ثبت‌نام سیم‌کارت ایرانی
	<Route
		key="sp-kit"
		path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Kit}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_Iranian} element={SPKit} />}
	/>,
	<Route
		key="sp-msisdn"
		path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Msisdn}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_Iranian} element={SPMsisdn} />}
	/>,
	<Route
		key="sp-profile"
		path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Profile}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_Iranian} element={SPProfile} />}
	/>,
	<Route
		key="sp-prefactor"
		path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.PreFactor}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_Iranian} element={SpPreFactor} />}
	/>,
	<Route
		key="sp-document"
		path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Document}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_Iranian} element={SPDocument} />}
	/>,
	<Route
		key="sp-final"
		path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Final}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_Iranian} element={SPFinalFactor} />}
	/>,

	// ثبت‌نام سیم‌کارت اتباع
	<Route
		key="spf-kit"
		path={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Kit}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_NonIranian} element={SPFKit} />}
	/>,
	<Route
		key="spf-msisdn"
		path={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Msisdn}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_NonIranian} element={SPFMsisdn} />}
	/>,
	<Route
		key="spf-authentication"
		path={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Authentication}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_NonIranian} element={SPFAuthentication} />}
	/>,
	<Route
		key="spf-profile"
		path={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Profile}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_NonIranian} element={SPFProfile} />}
	/>,
	<Route
		key="spf-prefactor"
		path={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.PreFactor}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_NonIranian} element={SPFPrefactor} />}
	/>,
	<Route
		key="spf-document"
		path={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Document}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_NonIranian} element={SPFDocument} />}
	/>,
	<Route
		key="spf-final"
		path={_adr.Root + _adr.SimCardPurchase.foreigners + _adr.SimCardPurchase.foreignersChild.Final}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_B2C_NonIranian} element={SPFFinalFactor} />}
	/>,

	// در انتظار آپلود مدارک
	<Route
		key="sp-pending-list"
		path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Pending.Index + _adr.SimCardPurchase.Pending.List}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_Report_UploadingDoc} element={SPListPendingDocument} />}
	/>,
	<Route
		key="sp-pending-upload"
		path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Pending.Index + _adr.SimCardPurchase.Pending.upload}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_Report_UploadingDoc} element={SPPendingDocument} />}
	/>,

	// گزارشات
	<Route
		key="sp-report"
		path={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Report.Index + _adr.SimCardPurchase.Report.List}
		element={<ProtectedRoute role={Roles.Dealer_RegisterSim_Report_One} element={SPReportList} />}
	/>,
];
